import { render, staticRenderFns } from "./MyPictureDetail.vue?vue&type=template&id=1c63e260&scoped=true"
import script from "./MyPictureDetail.vue?vue&type=script&lang=js"
export * from "./MyPictureDetail.vue?vue&type=script&lang=js"
import style0 from "./MyPictureDetail.vue?vue&type=style&index=0&id=1c63e260&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../_workspace/production-sync-20260815/repo/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c63e260",
  null
  
)

export default component.exports